import styled from "styled-components";

export default styled.p`
  font-size: 14px;
  padding-left: 15px;
  padding-right: 15px;
`;
